function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * This makes sure that each slider is unique and can appears multiple time on a same page.
 * Use `new VTX_Sliders` instead of using `new Swiper` directly.
 * Parameters are the same.
 * The object returned is not.
 * All `Swiper` objects can be found inside the `sliders` parameter.
 */
var VTX_Sliders = /*#__PURE__*/function () {
  "use strict";

  // jshint ignore:line

  function VTX_Sliders(selector) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, VTX_Sliders);
    this.selector = selector;
    this.args = args;
    this.sliders = [];
    this.slider_count = 0;
    this.paginations = null;
    this.next_btns = null;
    this.prev_btns = null;
    this.scrollbars = null;
    this.scrollbar_drag_els = null;
    this.init_sliders();
  }
  return _createClass(VTX_Sliders, [{
    key: "init_sliders",
    value: function init_sliders() {
      var _this = this;
      var sliders = document.querySelectorAll(this.selector);
      if (sliders.length) {
        this.set_paginations_of_args();
        this.set_navigations_of_args();
        this.set_scrollbars_of_args();
        sliders.forEach(function (slider) {
          return _this.init_slider_by_node(slider);
        });
      }
    }
  }, {
    key: "init_slider_by_node",
    value: function init_slider_by_node(slider) {
      this.increment_counts();
      var args_clone = this.get_args_clone();
      var index = this.slider_count - 1;
      var global_index = VTX_Sliders.global_slider_count - 1;
      var slider_unique_class = "slider-".concat(global_index);

      // Set unique class slider
      slider.classList.add(slider_unique_class);

      // Set unique class pagination
      if (this.paginations && 'undefined' !== typeof this.paginations[index]) {
        var unique_el_class = "".concat(slider_unique_class, "-pagination");
        this.paginations[index].classList.add(unique_el_class);
        args_clone.pagination.el = ".".concat(unique_el_class);
      }

      // Set unique class next btn
      if (this.next_btns && 'undefined' !== typeof this.next_btns[index]) {
        var _unique_el_class = "".concat(slider_unique_class, "-next-btn");
        this.next_btns[index].classList.add(_unique_el_class);
        args_clone.navigation.nextEl = ".".concat(_unique_el_class);
      }

      // Set unique class prev btn
      if (this.prev_btns && 'undefined' !== typeof this.prev_btns[index]) {
        var _unique_el_class2 = "".concat(slider_unique_class, "-prev-btn");
        this.prev_btns[index].classList.add(_unique_el_class2);
        args_clone.navigation.prevEl = ".".concat(_unique_el_class2);
      }

      // Set unique class scrollbar
      if (this.scrollbars && 'undefined' !== typeof this.scrollbars[index]) {
        var _unique_el_class3 = "".concat(slider_unique_class, "-scrollbar");
        this.scrollbars[index].classList.add(_unique_el_class3);
        args_clone.scrollbar.el = ".".concat(_unique_el_class3);
      }

      // Set unique class scrollbar drag el
      if (this.scrollbar_drag_els && 'undefined' !== typeof this.scrollbar_drag_els[index]) {
        var _unique_el_class4 = "".concat(slider_unique_class, "-scrollbar-drag-el");
        this.scrollbar_drag_els[index].classList.add(_unique_el_class4);
        args_clone.scrollbar.dragEl = ".".concat(_unique_el_class4);
      }

      // Add this slider to the lot found with `this.selector`.
      this.sliders.push(new Swiper(".".concat(slider_unique_class), args_clone));
    }
  }, {
    key: "increment_counts",
    value: function increment_counts() {
      ++VTX_Sliders.global_slider_count;
      ++this.slider_count;
    }
  }, {
    key: "get_args_clone",
    value: function get_args_clone() {
      var args_clone = Object.assign({}, this.args);
      args_clone.pagination = Object.assign({}, this.args.pagination);
      args_clone.navigation = Object.assign({}, this.args.navigation);
      args_clone.scrollbar = Object.assign({}, this.args.scrollbar);
      return args_clone;
    }
  }, {
    key: "set_paginations_of_args",
    value: function set_paginations_of_args() {
      if ('undefined' !== typeof this.args.pagination && 'undefined' !== typeof this.args.pagination.el) {
        this.paginations = document.querySelectorAll(this.args.pagination.el);
      }
    }
  }, {
    key: "set_navigations_of_args",
    value: function set_navigations_of_args() {
      if ('undefined' !== typeof this.args.navigation) {
        if ('undefined' !== typeof this.args.navigation.nextEl) {
          this.next_btns = document.querySelectorAll(this.args.navigation.nextEl);
        }
        if ('undefined' !== typeof this.args.navigation.prevEl) {
          this.prev_btns = document.querySelectorAll(this.args.navigation.prevEl);
        }
      }
    }
  }, {
    key: "set_scrollbars_of_args",
    value: function set_scrollbars_of_args() {
      if ('undefined' !== typeof this.args.scrollbar) {
        if ('undefined' !== typeof this.args.scrollbar.el) {
          this.scrollbars = document.querySelectorAll(this.args.scrollbar.el);
        }
        if ('undefined' !== typeof this.args.scrollbar.dragEl) {
          this.scrollbar_drag_els = document.querySelectorAll(this.args.scrollbar.dragEl);
        }
      }
    }
  }]);
}();
_defineProperty(VTX_Sliders, "global_slider_count", 0);